import React from 'react'
import { useLocalState } from '../../../shared/UseLocalState'
import { Person } from '../../../api'
import { authState } from '../../../state/Auth.state'

export const Riders = () => {
  /* STATE */
  const user = useLocalState<Person | null>(authState.user$, authState.user$.value)

  /* TEMPLATE */
  return (
    <div>
      <h2>Reiter</h2>
      <div>
        <pre>{JSON.stringify(user, null, 5)}</pre>
      </div>
    </div>
  )
}
